import type { ItemOffgrid, Opciones } from '../api'
import { FilasEquipo } from './FilasEquipo'

interface Props {
  activo: boolean
  alCambiarActivo: (v: boolean) => void
  equipos: Opciones['equipos']
  conBateria: boolean
  panel: ItemOffgrid
  alCambiarPanel: (v: ItemOffgrid) => void
  inversor: ItemOffgrid
  alCambiarInversor: (v: ItemOffgrid) => void
  bateria: ItemOffgrid
  alCambiarBateria: (v: ItemOffgrid) => void
}

/** Equipos elegidos a mano (opcional): para armar un kit mas pequeño que lo que cubre el consumo. */
export function EquiposAMano(p: Props) {
  return (
    <>
      <label className="casilla">
        <input type="checkbox" checked={p.activo} onChange={(e) => p.alCambiarActivo(e.target.checked)} /> Elegir los equipos a mano
        <small className="ayuda">Para armar un kit más pequeño. Apagado, el motor elige los equipos según el consumo.</small>
      </label>
      {p.activo && p.equipos && (
        <>
          <FilasEquipo titulo="Paneles" opciones={p.equipos.paneles} filas={[p.panel]} minimo={1} textoAgregar="" alCambiar={(f) => p.alCambiarPanel(f[0]!)} />
          <FilasEquipo titulo="Inversor" opciones={p.equipos.inversores} filas={[p.inversor]} minimo={1} textoAgregar="" alCambiar={(f) => p.alCambiarInversor(f[0]!)} />
          {p.conBateria && (
            <FilasEquipo titulo="Batería" opciones={p.equipos.baterias} filas={[p.bateria]} minimo={1} textoAgregar="" alCambiar={(f) => p.alCambiarBateria(f[0]!)} />
          )}
        </>
      )}
    </>
  )
}
